import { IconComponentProps } from '../IconTypes';

const GraphCollapse = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9958 7C9.76135 8.30327 9.00421 10.0632 9.00421 12C9.00421 13.9368 9.76135 15.6967 10.9958 17M14.9958 7C13.7613 8.30327 13.0042 10.0632 13.0042 12C13.0042 13.9368 13.7613 15.6967 14.9958 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.25"
    />
  </svg>
);

export default GraphCollapse;
